import React from 'react';
import { FieldWrapper } from './FieldWrapper';
import { TypeaheadInput } from './SelectTypeaheadField';
import { Icon } from '../Icon';
import { parseRenderOptions } from './utils';
import classNames from 'classnames';

export class MapField extends React.Component {
  constructor(props) {
    super(props);
    this.state = { newKey: '', newValue: '' };
  }

  editValueChange = key => ({ target: { value } }) => {
    this.props.onChange(this.props.value.set(key, value));
  };

  removeValue = key => () => {
    this.props.onChange(this.props.value.remove(key));
  };

  handleKeyChange = newKey => {
    this.setState({ newKey });
  };

  handleValueChange = ({ target: { value: newValue } }) => {
    this.setState({ newValue });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { prevKey, prevValue } = prevState;
    const { newKey, newValue } = this.state;
    if ((!prevKey || !prevValue) && newKey && newValue) {
      this.props.onChange(this.props.value.set(newKey, newValue));
      this.setState({ newKey: '', newValue: '' });
    }
  }

  render() {
    const renderOptions = parseRenderOptions(this.props, { isFloating: false });

    const keys = this.props.value.keySeq().toSet();
    const availableOptions = this.props.options.filter(
      option => !keys.includes(option.get('value')),
    );
    return (
      <FieldWrapper {...this.props} renderOptions={renderOptions} fieldset>
        {this.props.value
          .mapEntries(([key, value], i) => [
            key,
            <div
              className={classNames('input-group input-group--map-field', {
                'input-group-sm': renderOptions.size === 'sm',
              })}
              key={i}
            >
              <span className="input-group-text">{key}</span>
              <input
                className={classNames('form-control', {
                  'form-control-sm': renderOptions.size === 'sm',
                })}
                disabled={!this.props.enabled}
                onBlur={this.props.onBlur}
                onChange={this.editValueChange(key)}
                onFocus={this.props.onFocus}
                type="text"
                value={value}
                form={this.props.form}
              />
              {this.props.enabled && (
                <button
                  className="btn btn-table"
                  type="button"
                  onFocus={this.props.onFocus}
                  onBlur={this.props.onBlur}
                  onClick={this.removeValue(key)}
                  aria-label="Clear Value"
                  title="Clear Value"
                >
                  <Icon name="trash" md />
                </button>
              )}
            </div>,
          ])
          .toList()
          .push(
            this.props.enabled ? (
              <div
                className={classNames('input-group input-group--map-field', {
                  'input-group-sm': renderOptions.size === 'sm',
                })}
                key={this.props.value.size}
              >
                <TypeaheadInput
                  componentOptions={{
                    size: renderOptions.size,
                    fieldClassName: renderOptions.fieldClassName,
                  }}
                  disabled={!this.props.enabled}
                  onBlur={this.props.onBlur}
                  onChange={this.handleKeyChange}
                  onFocus={this.props.onFocus}
                  options={availableOptions}
                  value={this.state.newKey}
                  placeholder={this.props.placeholder}
                  form={this.props.form}
                  invalid={renderOptions.hasErrors}
                />
                <input
                  className={classNames('form-control', {
                    'form-control-sm': renderOptions.size === 'sm',
                  })}
                  disabled={!this.props.enabled}
                  onBlur={this.props.onBlur}
                  onChange={this.handleValueChange}
                  onFocus={this.props.onFocus}
                  type="text"
                  value={this.state.newValue}
                  form={this.props.form}
                />
              </div>
            ) : null,
          )
          .push(
            !this.props.enabled && this.props.value.size === 0 ? (
              <div
                className={classNames('input-group input-group--map-field', {
                  'input-group-sm': renderOptions.size === 'sm',
                })}
                key="-1"
              >
                <span className="input-group-text">
                  <span className="visually-hidden">
                    Field is disabled and has no value
                  </span>
                  <span className="text-muted">{this.props.placeholder}</span>
                </span>
                <input
                  className={classNames('form-control', {
                    'form-control-sm': renderOptions.size === 'sm',
                  })}
                  disabled={true}
                  type="text"
                />
              </div>
            ) : null,
          )}
      </FieldWrapper>
    );
  }
}
